const dashboard_wrapper = {
	otp_not_enabled_dialog: {
		button: "2FA instellen",
		description:
			"Voor deze pagina is tweestapsverificatie (2FA) vereist. Stel dit in voordat u verder kunt gaan.",
		title: "Geen tweestapsverificatie (2FA) ingesteld",
	},
	otp_required_dialog: {
		description:
			"Voor deze pagina is tweestapsverificatie (2FA) vereist. Voer uw 2FA code in voordat u verder kunt gaan.",
		title: "Tweestapsverificatie (2FA) vereist!",
	},
	paid_services_disabled: {
		description:
			"Ze zijn alleen beschikbaar voor bedrijven en Nederlandse burgers. Als u denkt dat dit niet op u van toepassing is, laat het ons dan weten. Als u geen Nederlandse burger bent, kunnen we mogelijk een company in uw land vinden dat onze diensten levert.",
		title: "Betaalde diensten zijn voor u uitgeschakeld.",
	},
};

export default dashboard_wrapper;
